export const InfoSectionStyles = {
    content: "inline-flex flex-col items-center max-w-[370px]",
    title: "text-xl text-center sm:text-2xl font-medium text-gray-800 mb-2",
    message: "text-[var(--iw-color-info)] font-normal text-sm break-words justify-center text-center",
    action: "container max-w-full pt-7 mt-3 block sm:hidden"
};